import React, { Component } from 'react';
import { Provider } from 'react-redux';

import configureStore from './store';
import createRoutes from './routes';

const store = configureStore();

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        {createRoutes()}
      </Provider>
      );
  };
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js